import { VortexClient } from "@client/index";

/**
 * Union type for all global Vortex events.
 */
export type VortexGlobalEvent = VortexGlobalDownloadEvent;

/**
 * Event class for proxified download interception.
 */
export class VortexGlobalDownloadEvent extends Event {
	type = "download";
	constructor(public download: VortexDownload) {
		super("download");
	}
}

/**
 * Map for all global Vortex events with their corresponding event types.
 */
export type VortexGlobalEvents = {
	download: VortexGlobalDownloadEvent;
};

/**
 * Event for proxified download interception.
 */
export type VortexDownload = {
	filename?: string;
	url: string;
	type: string;
	body: ReadableStream<Uint8Array>;
	length: number;
};

/**
 * Union type for all Vortex proxified navigation events.
 */
export type VortexEvent =
	| VortexNavigateEvent
	| VortexUrlChangeEvent
	| VortexContextEvent;

/**
 * Type map for all Vortex navigation events with their corresponding event types.
 */
export type VortexEvents = {
	navigate: VortexNavigateEvent;
	urlchange: VortexUrlChangeEvent;
	contextInit: VortexContextEvent;
};

/**
 * Navigation event class fired when Vortex frame navigates to a new proxified URL.
 */
export class VortexNavigateEvent extends Event {
	type = "navigate";
	constructor(public url: string) {
		super("navigate");
	}
}

/**
 * URL change event class fired when the proxified URL changes in a Vortex frame.
 */
export class VortexUrlChangeEvent extends Event {
	type = "urlchange";
	constructor(public url: string) {
		super("urlchange");
	}
}

/**
 * Event class fired when Vortex initializes in a frame.
 */
export class VortexContextEvent extends Event {
	type = "contextInit";
	constructor(
		public window: Self,
		public client: VortexClient
	) {
		super("contextInit");
	}
}
